import 'livewire-sortable';
import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

if (process.env.NODE_ENV !== 'production') {
    Pusher.logToConsole = true;
}

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: window.location.hostname,
    wsPort: 6001,
    enableStats: false,
    enabledTransports: ['ws', 'wss'],
    encrypted: true,
});

window.Huutopiste = {};
